import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () =>{
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'farm_name',
            label: i18n.t('common_words.farm'),
            minWidth: 80,
            align: 'left',
            sortable: true,
        }, {
            prop: 'plants_seeds_recieved',
            label: i18n.t('sowing.plants_seeds_recieved'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.plants_seeds_recieved
                );
            },
        },
        {
            prop: 'total_plants_seeds_pruning',
            label: i18n.t('sowing.total_plants_seeds_planted_pruning'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds_pruning
                );
            },
        },
        {
            prop: 'total_plants_seeds',
            label: i18n.t('sowing.total_plants_seeds_planted'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds
                );
            },
        },
        {
            prop: 'total_plants_seeds_replant',
            label: i18n.t('sowing.total_plants_seeds_replant'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds_replant
                );
            },
        },
    ];
    const Search = { ...Tables.Search };

    return { Table, Search }
}

export default configTable;